import { useState, useRef, useEffect } from 'react'
import clsx from 'clsx'
import './icon-menu.scss'

const IconMenu = ({
  children,
  icon,
  containerClass,
  tooltip,
  menuPosition = 'left',
}) => {
  const dropdownRef = useRef(null)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const { current } = dropdownRef
    if (current) {
      const items = current.querySelectorAll('.icon-menu-menu button')
      if (items && items.length > 0) {
        items.forEach((item) => {
          item.addEventListener('click', () => {
            setOpen(false)
          })
        })
      }
    }
  }, [dropdownRef])

  const handleOnClick = () => {
    setOpen((val) => !val)
  }

  const handleOnBlur = () => {
    setTimeout(() => {
      if (!dropdownRef.current.contains(document.activeElement)) {
        setOpen(false)
      }
    }, 0)
  }

  return (
    <div
      className={clsx('icon-menu relative', containerClass)}
      onBlur={handleOnBlur}
      ref={dropdownRef}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        onClick={handleOnClick}
        className="flex align-center justify-center w-full disable-hover"
        data-tooltip={tooltip}
      >
        {icon}
      </button>
      <div
        className={clsx(
          'absolute top-full bg-gray-lighter drop-shadow-dark rounded overflow-hidden icon-menu-menu z-10',
          {
            hidden: !open,
            'right-0': menuPosition === 'left',
            'left-0': menuPosition === 'right',
          },
        )}
      >
        {children}
      </div>
    </div>
  )
}

export default IconMenu
